<template>
  <div>
    <div class="mb-2 sm:grid sm:grid-cols-2 sm:justify-items-stretch">
      <div class="mr-2 flex justify-self-start">
        <div class="mr-2">
          <TButtonSvg label="Select All" color="white" @click="selectAllRecords">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <polyline points="9 11 12 14 20 6" />
              <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" />
            </svg>
          </TButtonSvg>
        </div>
        <div v-if="selectedContacts.length > 0" class="mr-2">
          <TButtonSvg label="Deselect All" color="white" @click="deselectAllRecords">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <polyline points="9 11 12 14 20 6" />
              <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" />
            </svg>
          </TButtonSvg>
        </div>
        <div v-if="selectedContacts.length > 0" class="mr-2">
          <TButtonSvg label="Mark as Read" color="white" @click="markSelectedAsRead">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <path d="M14 3v4a1 1 0 0 0 1 1h4" />
              <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
              <line x1="9" y1="7" x2="10" y2="7" />
              <line x1="9" y1="13" x2="15" y2="13" />
              <line x1="13" y1="17" x2="15" y2="17" />
            </svg>
          </TButtonSvg>
        </div>
      </div>
      <div class="justify-self-end flex">
        <TButtonSvg label="Export" color="white" @click="exportMessages">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" />
            <line x1="17" y1="7" x2="7" y2="17" />
            <polyline points="8 7 17 7 17 16" />
          </svg>
        </TButtonSvg>
      </div>
    </div>
    <div v-if="!$store.state.general.loadingSpinner" class="flex flex-col">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
          <div
            v-if="contacts.length == 0"
            class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          >
            Send your first message by creating a contact and using the chat feature!
          </div>
          <table class="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th
                  v-for="column of columns"
                  :key="column"
                  class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  <div v-if="column != 'created_at'">
                    {{ column }}
                  </div>
                </th>
                <th class="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr
                v-for="record of contacts"
                :key="record.id"
                @click="handleInboxChat(record.id, record.Name.title)"
                class="cursor-pointer hover:bg-gray-50"
              >
                <td v-for="key of Object.keys(record)" :key="key" class="px-6 py-4 border-b border-gray-200">
                  <div v-if="key == 'Name'">
                    <div class="flex items-center">
                      <input
                        type="checkbox"
                        class="h-4 w-4 cursor-pointer text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                        @click.stop
                        @click="recordChecked($event, record.id)"
                        :checked="selectedContacts.includes(record.id)"
                      />
                      <div class="ml-4">
                        <div class="text-sm leading-5 font-medium text-gray-900">
                          <router-link :to="`/contacts/${record.id}`" class="text-indigo-600 hover:text-indigo-900">{{
                            record.Name.title
                          }}</router-link>
                          <span class="green-label" v-if="record.Name.status == 'Unread'">{{
                            record.Name.status
                          }}</span>
                        </div>
                        <div class="text-sm leading-5 text-gray-500">
                          {{ record.Name.description }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <span
                    v-else-if="key == 'Status'"
                    :class="record[key] == 'Unsubscribed' ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'"
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                  >
                    {{ record[key] }}
                  </span>
                  <div class="text-sm leading-5 text-gray-900 truncate" v-else-if="key == 'created_at'">
                    {{ fromNow(record[key]) }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <LoadingList />

    <Pagination :startEntry="startEntry" :endEntry="endEntry" :total="total" />

    <Chat v-if="showInboxChat" :record="record" @handleContactChatCancel="handleContactChatCancel" />
  </div>
</template>

<script>
import Chat from '../shared/Chat.vue';
import LoadingList from '../shared/LoadingList.vue';
import Pagination from '../shared/Pagination.vue';
import DateUtility from '../../utilities/dates';

export default {
  components: {
    Chat,
    LoadingList,
    Pagination,
  },
  data() {
    return {
      contacts: [],
      startEntry: 0,
      endEntry: 0,
      total: 0,
      page: this.$route.query.page ? this.$route.query.page : 1,
      showInboxChat: false,
      record: {
        name: '',
        id: '',
      },
      selectedContacts: [],
    };
  },
  mounted() {
    this.getContacts();
    if (this.page == 1) {
      this.getCableContactMessagesInbox();
    }
  },
  channels: {
    ContactMessagesInboxChannel: {
      connected() {
        console.log('inbox channel connected');
      },
      received(data) {
        console.log('inbox channel received');
        let fetchedContacts = [];
        for (let record of data.records) {
          fetchedContacts.push({
            Name: {
              title: record.name ? record.name : record.id,
              description: record.body,
              status: record.status,
            },
            created_at: record.created_at,
            id: record.id,
          });
        }
        this.contacts = fetchedContacts;
        this.total = data.total;
        this.startEntry = data.start_entry;
        this.endEntry = data.end_entry;
      },
    },
  },
  unmounted() {
    this.$cable.unsubscribe('ContactMessagesInboxChannel');
  },
  methods: {
    ...DateUtility,
    selectAllRecords() {
      const self = this;
      let currentSelectedContacts = self.selectedContacts;
      for (let contact of self.contacts) {
        currentSelectedContacts.push(contact.id);
      }
      self.selectedContacts = [...new Set(self.selectedContacts)];
    },
    deselectAllRecords() {
      this.selectedContacts = [];
    },
    markSelectedAsRead() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/contact_messages/bulk_mark_as_read`, {
        method: 'POST',
        body: JSON.stringify({
          ids: self.selectedContacts,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          this.selectedContacts = [];
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Messages marked as read',
              alertDescription: 'Your selected messages were marked as read.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Messages marked as read error',
              alertDescription: data.message,
            });
          }
        });
    },
    recordChecked(e, recordId) {
      const self = this;
      if (e.currentTarget.checked) {
        self.selectedContacts.push(recordId);
      } else {
        let newSelectedContacts = self.selectedContacts.filter(item => item != recordId);
        self.selectedContacts = newSelectedContacts;
      }
    },
    handleInboxChat(id, name) {
      const self = this;
      self.record.name = name;
      self.record.id = id;
      self.showInboxChat = true;
    },
    handleContactChatCancel() {
      const self = this;
      self.showInboxChat = false;
    },
    getContacts() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      let pageQuery = self.$route.query.page ? `page=${self.$route.query.page}` : '';
      let keywordQuery = self.$route.query.keyword_id ? `keyword_id=${self.$route.query.keyword_id}` : '';
      fetch(`/api/contact_messages?${pageQuery}&${keywordQuery}`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          let fetchedContacts = [];
          for (let record of data.records) {
            fetchedContacts.push({
              Name: {
                title: record.name ? record.name : record.id,
                description: record.body,
                status: record.status,
              },
              created_at: record.created_at,
              id: record.id,
            });
          }
          self.contacts = fetchedContacts;
          self.total = data.total;
          self.startEntry = data.start_entry;
          self.endEntry = data.end_entry;
        });
    },
    getCableContactMessagesInbox() {
      const self = this;
      self.$cable.subscribe({
        channel: 'ContactMessagesInboxChannel',
      });
    },
    exportMessages() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/contact_messages/download_csv`, {
        headers: {
          'Content-Type': 'text/csv',
        },
      })
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.blob();
        })
        .then(data => {
          let file = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = file;
          a.download = 'message_export.csv';
          a.click();
          window.URL.revokeObjectURL(file);
        });
    },
  },
  computed: {
    columns() {
      if (this.contacts.length > 0) {
        let columns = Object.keys(this.contacts[0]).filter(column => column != 'id');
        return columns;
      } else {
        return [];
      }
    },
  },
};
</script>

<style></style>
